<template>
<div>

<v-dialog max-width="600" min-width="600" v-model="settings.visible" :fullscreen="$vuetify.breakpoint.smAndDown" transition="v-fade-transition" hide-details xpersistent :hide-overlay="false" scrollable>
<div :style="{height: dialogHeight}" class="dialog-container" style="width:100%">

    <div class="dialog-header">
        <v-toolbar dark flat dense class="primary">
            <v-toolbar-title class="white--text">{{dialogTitle}}</v-toolbar-title>
            <v-spacer/>
            <v-menu offset-y>
                <template v-slot:activator="{ on }">
                <v-icon v-on="on">more_vert</v-icon>
                </template>
                <v-list>
                    <v-list-item @click="goToElementMaintenance">
                        <v-list-item-title>Maintenance</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>            
        </v-toolbar>
        <div class="element-title-bar">{{model.title}}</div>
    </div>

    <div class="dialog-body">
    <v-row wrap>
    <v-col cols="5">

        <!-- Navigation -->

        <!-- <v-toolbar flat class="transparent">
            <v-list class="pa-0">
            <v-list-item>
                <v-list-item-avatar>
                <img src="https://randomuser.me/api/portraits/men/85.jpg" >
                </v-list-item-avatar>
                <v-list-item-content>
                <v-list-item-title>{{model.title}}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            </v-list>
        </v-toolbar> -->

        <v-list class="pt-0" dense>
            <v-divider></v-divider>

            <v-list-item @click="tab = 'Details'" :class="{'active-tab': tab == 'Details'}">
            <v-list-item-action>
                <v-icon>subject</v-icon>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title>Details</v-list-item-title>
            </v-list-item-content>
            </v-list-item>

            <v-list-item @click="tab = 'Advanced'" :class="{'active-tab': tab == 'Advanced'}">
            <v-list-item-action>
                <v-icon>category</v-icon>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title>Advanced</v-list-item-title>
            </v-list-item-content>
            </v-list-item>

            <v-list-item @click="tab = 'Display'" :class="{'active-tab': tab == 'Display'}">
            <v-list-item-action>
                <v-icon>visibility</v-icon>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title>Display</v-list-item-title>
            </v-list-item-content>
            </v-list-item>

            <v-list-item @click="tab = 'Filters'" :class="{'active-tab': tab == 'Filters'}">
            <v-list-item-action>
                <v-icon>blur_linear</v-icon>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title>Filters</v-list-item-title>
            </v-list-item-content>
            </v-list-item>

            <v-list-item @click="tab = 'Tasks'" :class="{'active-tab': tab == 'Tasks'}">
            <v-list-item-action>
                <v-icon>dns</v-icon>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title>Tasks</v-list-item-title>
            </v-list-item-content>
            </v-list-item>

        </v-list>

    </v-col>
    <v-col cols="7">
        <div class="pa-4">

        <!-- Fields -->

            <template v-if="tab == 'Details'" style="height:600px"> 
            <!-- height due to bug. v-selects wont scroll unless a parent element scrolls -->   

            <v-select v-if="!typeHasValue" :items="typeOptions" v-model="model.type" label="Type"></v-select> 
            <v-text-field @blur="setDefaultName" ref="focus" v-model="model.title" label="Title"></v-text-field>

            <v-checkbox v-if="model.type == 'Text'" v-model="model.multiLine" label="Multi-line" />

            <v-textarea v-if="isVisible('Value')" v-model="model.value" label="Value" :rows="3"></v-textarea>
            

            <v-text-field v-if="model.type == 'List' || model.type == 'Options' || model.type == 'Status'" ref="optionsText" v-model="model.options" label="Options"></v-text-field>
            <v-checkbox v-if="model.type == 'List'" v-model="model.allowCustomText" label="Allow custom text" />
            

            <v-text-field v-if="!nameHasValue" v-model="model.name" label="Field Name"></v-text-field>

            <!-- Tab -->
            <template v-if="model.type == 'Tab'">
                <v-switch v-model="model.complete" label="Complete" color="primary" />  
            </template>


            <!-- Button -->

            <template v-if="model.type == 'Button'">
                <v-select v-model="model.buttonAction" :items="buttonActionOptions" label="Button Action" />
                <v-select v-model="model.buttonElements" :items="buttonElementsOptions" label="Elements Affected" />
                <v-text-field v-model="model.buttonElementCount" label="How many"></v-text-field>
                <v-select v-model="model.buttonIcon" :items="buttonIconOptions" label="Button Icon" clearable />
                <v-checkbox v-model="model.primary" label="Blue" />

            </template>

            <!-- Email -->

            <template v-if="model.type == 'Email'">
                <v-text-field v-model="model.emailGroup" label="Email Template Group"></v-text-field>
                <v-text-field v-model="model.emailName" label="Email Template Name"></v-text-field>
                <v-select v-bind:items="roles" v-model="model.role" clearable label="Send to Role"></v-select>
                <v-switch v-model="model.complete" label="Complete" color="primary" />  
                <v-text-field v-model="model.completeMessage" label="Message when completed"></v-text-field>                          
                <v-text-field v-model="model.toField" label="Send to Field"></v-text-field>                          
            </template>

            <!-- SMS -->
            <template v-if="model.type == 'SMS'">
                <v-text-field v-model="model.message" label="Message"></v-text-field>                          
                <v-select v-bind:items="roles" v-model="model.role" label="Send to Role"></v-select>
                <v-switch v-model="model.complete" label="Complete" color="primary" />  
            </template>

            <!-- Contact Selector -->

            <template v-if="model.type == 'Contact Selector'">
                <v-combobox v-bind:items="roles" v-model="model.role" label="Role" chips />                       
            </template>

            <!-- Contact -->
            <template v-if="model.type == 'Contact'">
                <v-combobox v-bind:items="roles" v-model="model.role" label="Role" />
            </template>            

            <!-- User Chooser -->

            <template v-if="model.type == 'User Chooser'">
                <v-combobox v-bind:items="roles" v-model="model.role" label="Role" chips />                       
            </template>
  
            <!-- Lookup -->
            <template v-if="model.type == 'Lookup'">
                <v-text-field v-model="model.lookup" label="Lookup Path" hint="eg. [lender]/[broker]/Broker Id"></v-text-field>
                <v-checkbox v-model="model.help" label="Show in Help Panel" hide-details/>
                <v-checkbox v-model="model.global" label="Global" hint="All users share accross the system"/>
            </template>

            <!-- Widget -->
            <template v-if="model.type == 'Widget'">
                <v-select v-bind:items="widgetOptions" v-model="model.widget" label="Which Widget" ></v-select>
                <v-select v-bind:items="[1,2]" v-model="model.version" label="Widget Version" ></v-select>
            </template>

            <!-- Scheduler -->
            <template v-if="model.type == 'Scheduler'">
                <v-combobox v-bind:items="['1', '2', '3', '4', '5', '6', '7', '10', '14', '21']" v-model="model.days" label="Days till follow up" />
                <v-switch v-model="model.complete" label="Complete" color="primary" />  
                <v-text-field v-model="model.taskText" label="Task Text" />
                <v-combobox v-bind:items="roles" v-model="model.role" label="Assign to Role" hint="Leave blank for current user" />

            </template>

            <!-- Billing Charge -->
            <template v-if="model.type == 'Charge'">
                <CurrencyBox v-model="model.amount" label="Amount" />
                <v-switch v-model="model.complete" label="Complete" color="primary" />  
            </template>

            <!-- Date -->
            <template v-if="model.type == 'Date'">
                <v-switch v-model="model.short" label="Short Format" color="primary" />
                <div class="section-heading vertical-margin">Relative to Another Date</div>
                <v-combobox v-model="model.relativeTo" label="Source Element Name" :items="dateElementNames" clearable/>

            </template>

            <!-- Html -->
            <template v-if="model.type == 'Html'">
                <v-textarea v-model="model.value" label="Html to Display" />                                   
            </template>
        
            <!-- Jump -->
            <template v-if="model.type == 'Jump'">
                <v-combobox v-bind:items="elementNames" v-model="model.target" label="Jump to Element" />
            </template>

            <!-- File (DEPRECATED)-->
            <template v-if="model.type == 'File'">
                <v-switch v-model="model.complete" label="Complete" color="primary" />  
            </template>

            <!-- File Upload -->
            <template v-if="model.type == 'File Upload'">
                <v-switch v-model="model.complete" label="Complete" color="primary" /> 
                <v-text-field v-model="model.targetName" label="Target File Name"></v-text-field>
            </template>
           
            <!-- Outstanding -->
            <template v-if="model.type == 'Outstanding'">
                <v-textarea :rows="3" v-model="model.text" label="Outstanding Item" />                                   
                <v-textarea :rows="3" v-model="model.response" label="Response" />   
                <v-select v-bind:items="statusOptions" v-model="model.status" label="Status" ></v-select>
                                                
            </template>

            <!-- Exporter -->
            <template v-if="model.type == 'Exporter'">
                <v-switch v-model="model.complete" label="Complete" color="primary" />  
            </template>

            <v-slider v-model="model.width" 
                v-if="model.type != 'Tab'"
                :label="`Width (${model.width}%)`" :step="10" 
            />
            
            </template>

            <!-- Advanced -->


            <div v-if="tab == 'Advanced'" style="height:600px"> 
                <v-select :items="typeOptions" v-model="model.type" label="Element Type"></v-select> 
                <v-text-field v-model="model.name" label="Field Name"></v-text-field>
                <!-- <v-text-field v-model="model.help" label="Help Link"></v-text-field> -->
                <v-checkbox v-model="model.dashboards" label="Used in dashboards" hide-details/>
                <v-checkbox v-model="model.locked" label="Locked" hide-details/>
                <v-checkbox v-model="model.labelTop" v-if="model.type=='Switch' || model.type=='Slider'" label="Label on Top" hide-details/>
                <v-checkbox v-model="model.milestone" label="Milestone" hide-details/>
                <v-text-field v-model="model.transactionField" label="Transaction Field"></v-text-field>

                <!-- <div class="section-heading vertical-margin">Schedule</div>
                <v-text-field suffix="days" v-model="model.scheduleDays" label="Shedule For"></v-text-field>
                <v-autocomplete v-model="model.scheduleTrigger" label="After Completion Of" :items="elementNames" />
                <v-text-field v-model="model.scheduleText" label="Task Text"></v-text-field> -->
                <v-btn @click="clearValue">Clear Value</v-btn>
            </div>
            

            <!-- Display Tab -->

            <div v-if="tab == 'Display'">
                <v-checkbox v-if="isContainer" v-model="model.reverse" label="Reverse Items" hint="Shows elements in reverse order" hide-details xpersistent-hint/>
                
                <v-checkbox v-model="model.compact" label="Compact" hint="Takes up less space" hide-details/> 
                <v-checkbox v-model="model.hideHeading" label="Hide Heading" hint="Takes up less space" hide-details xpersistent-hint/> 
                <v-checkbox v-model="model.showHint" label="Show Hint" hint="Shows in expanded mode" hide-details xpersistent-hint/>
                <v-checkbox v-model="model.collapsable" label="Collapsable" hide-details/>
                <!-- <v-select v-if="model.column" v-model="model.width" :items="['Tiny', 'Small', 'Medium', 'Large', 'X-Large']" label="Column Width" /> -->
                <v-checkbox v-model="model.dontPrint" label="Don't Print" hide-details />
                <!-- <v-checkbox v-model="model.alwaysLast" label="Always Last" hint="Always shows at end" hide-details xpersistent-hint/> -->
                <!-- <v-checkbox v-model="model.loading" label="Loading" hint="" hide-details xpersistent-hint/> -->
                <!-- <v-text-field v-if="isContainer" v-model="model.height" label="Height"/> -->
                <v-text-field v-if="model.order" v-model="model.order" label="Sort Order" disabled />
       
            </div>

            <div v-if="tab == 'Formula'">
                <v-text-field v-model="model.value" label="Value"/>
                <v-text-field v-model="formulaResult" disabled label="Result" hide-details />
                
                <!-- <v-text-field v-model="model.formula" label="Formula" /> -->
            </div>

            <!-- Actions Tab -->
            <!-- <div v-if="tab == 'Actions'">
                <v-btn v-if="model.type == 'Tab'" @click="$emit('action', 'import', model)">Import Templates</v-btn>
            </div> -->

             <!-- Filter Tab -->

            <div v-if="tab == 'Filters'">
            
                <div v-if="!this.filterArray.length">
                    No Filters
                </div>

                <div v-for="filter in filterArray" :key="filter.name" class="action-panel">

                    <div style="flex-basis:50px;padding:8px;">
                        <v-icon>visibility</v-icon>
                    </div>

                    <div style="flex-grow:1;padding:8px;">
                        {{ filter.type }} when <b>{{filter.name}}</b> {{filter.operator.toLowerCase()}}: '{{filter.values.join('/')}}'
                    </div>

                    <div>
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                            <v-btn v-on="on" icon ripple>
                                <v-icon color="grey lighten-1">keyboard_arrow_down</v-icon>
                            </v-btn>
                            </template>
                            <v-list>
                                <v-list-item @click="editFilter(filter)">
                                    <v-list-item-title>Edit Filter</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="deleteFilter(filter)">
                                    <v-list-item-title>Delete Filter</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                    
                </div>


                <div class="mt-2">
                    <v-btn @click="addFilter">Add Filter</v-btn>
                </div>
                
            </div>  

            <!-- Tasks -->

            <div v-if="tab == 'Tasks'">

                <div class="small-text" style="margin-top:-15px">Automatic tasks can be added to your task list when input for this element is completed.</div>

                <v-list two-line subheader class="selectable">
                    <v-list-item v-for="(task, taskIndex) in (model.tasks || [])" :key="taskIndex" @click="editingTask = task" :class="{active: task == editingTask}" >
                        <v-list-item-avatar>
                        <v-icon>dns</v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content>
                        <v-list-item-title v-text="task.title"></v-list-item-title>
                        <v-list-item-subtitle>{{task.assigned}} in {{task.days}} days</v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action>
                        <v-btn @click="deleteAutomaticTask(task)" icon>
                            <v-icon color="grey lighten-1">cancel</v-icon>
                        </v-btn>
                        </v-list-item-action>
                    </v-list-item>

                    <v-divider inset></v-divider>

                    <v-list-item @click="addAutomaticTask">
                        <v-list-item-avatar>
                        <v-icon>add_circle</v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content>
                        <v-list-item-title>Add an automatic task</v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>
                <template v-if="editingTask">
                    <div class="section">Task Details</div>
                    <v-text-field v-model="editingTask.title" label="Task Text" />
                    <v-select v-bind:items="roles" v-model="editingTask.role" label="Assign to Role"></v-select>
                    <v-combobox v-bind:items="['1', '2', '3', '4', '5', '6', '7', '10', '14', '21']" v-model="editingTask.days" label="Days" />
                </template>
            </div>

        
        <!-- </v-form>    -->
        </div>
    </v-col>
    </v-row>   
    </div>

    <div class="dialog-footer">
        <template>
            <DeleteButton v-if="this.model.key" style="float:left" @delete="deleteElement" />
            <v-btn text @click.native="cancel">Cancel</v-btn>
            <v-btn text @click.native="save" :disabled="!valid">Save</v-btn>                
        </template>
    </div>
    
</div> 
</v-dialog>

<FilterEditor 
    :settings="filterEditorDialog.settings" :elements="filterEditorDialog.elements" :filterProp="filterEditorDialog.filter"
    @save="saveFilter" @delete="deleteFilter"
/>

</div>
</template>

<script>
    import Vue from 'vue'
    import FirebaseHelpers from '../helpers/FirebaseHelpers'
    import Utilities from '../helpers/Utilities'
    import DeleteButton from '../ui-elements/DeleteButton'
    import DataHelpers from '../helpers/DataHelpers'
    import OrderHelpers from '../helpers/OrderHelpers'
    import NumberHelpers from '../helpers/NumberHelpers'
    import ElementHelpers from '../helpers/ElementHelpers'
    import StringHelpers from '../helpers/StringHelpers'
    import FilterEditor from '../ui-elements/FilterEditor'
    import FilterHelpers from '../helpers/FilterHelpers'
    import LookupData from '../helpers/LookupData'
    import CurrencyBox from '../ui-elements/CurrencyBox'
    
    export default {
    props:{
        settings: Object,
        data: Object,
        model: Object
    },
    components:{
        DeleteButton,
        FilterEditor,
        CurrencyBox,
    },
    data() {
        return {
            tab: 'Details',
            nameRules: [
                v => !!v || 'Name is required',
                v => (v && v.length >= 3) || 'Name must be greater than 3 characters'
            ],
            typeHasValue: false,
            nameHasValue: false,

            filterEditorDialog: {
                settings: {
                    visible: false,
                    title: 'Add a Filter'
                },
                filter: null,
                elements: []
            },     
            filterArray: [],
            editingTask: {},     
        }
    },
    computed: {
        valid() {
            return this.model.type && this.model.name && this.model.title
        },

        elements() {
            return ElementHelpers.getElements()
        }, 
        dateElements() {
            return this.elements.filter(o => o.type == 'Date')
        }, 

        elementNames() {
            return this.elements.filter(o => o.name).sort(OrderHelpers.sortByName).map(o => o.name)
        },
        dateElementNames() {
            return this.dateElements.filter(o => o.name).sort(OrderHelpers.sortByName).map(o => o.name)
        },

        // formulaResult() {
        //     return MergeHelpers.parseFormula(this.model.value, this.fields)
        // },

        operators() {
            return LookupData.operators()
        },

        // fields: {
        //     get: function() {
        //         return this.$store.getters.fields
        //     },
        //     set: function(newFields) {
        //         this.$store.commit('setFields', newFields)
        //     }
        // }, 

        dialogHeight() {
            if(this.$vuetify.breakpoint.smAndDown)
                return '100%'
            else
                return '500px'
        },

        dialogTitle() {
            if(this.model.type)
                return this.model.type + ' Details'
            else
                return 'Element Details'
        },

        isContainer() {
            if(!this.model.type)
                return false

            return this.model.type.startsWith('Heading') || this.model.type == 'Tab'
        },

        

        contactDialogImageVisible () {
            if(this.contact.image && 
            this.contact.image.indexOf('transparent') < 0)
                return true
            else
                return false
        },
        contactImage () {
            if(this.contact.image)
                return this.contact.image
            else    
                return '/static/images/transparent.png'
        },

        buttonActionOptions() {
            return ['Clone', 'Delete']
        },

        buttonElementsOptions() {
            return ['Previous', 'Next', 'Section']
        },
  
        widgetOptions() {
            return ['Import Outstandings', 'Outstandings Diagram', 'Element Summary', 'Loan Diagram', 'Transaction Summary', 'Coming Up']
        },

        statusOptions() {
            return LookupData.outstandingStatuses()
        },

        buttonIconOptions() {
            return ['add', 'delete', 'edit']
        },

        typeOptions() {
            return ['Section',  
                    'Text', 'Date', 'DateTime', 'Currency', 'Percent', 'List', 'Options', 'Switch', 'Checkbox', 'Checkbox List', 'Checklist', 'Slider', 
                    'Button', 'Status', 'Tab', 'Comment', 'Field Summary',
                    'Email', 'Scheduler', 'SMS', 'Contact Selector', 'User Chooser', 'File Upload', 'Lookup', 'Html', 'Rating', 'Charge', 'Heading', 'Outstanding', 'Jump', 'Contact', 'Widget', 'Divider', "Exporter", "LoanAttributes"]
        },   

        roles() {
            return this.$store.getters.groups.filter(o => o.role == true).map(o => o.name)
        },
        
        childNames() {
            let children = ElementHelpers.getChildren(this.model, this.elements)
            return children.map(o => o.name)
        },

        backgroundOptions() {
            return ['Grey']
        }
    },
    methods: {

        addAutomaticTask() {
            this.model.tasks = this.model.tasks || []
            this.model.tasks.push({
                title: 'Follow Up',
                days: 2,
            })
            this.editingTask = this.model.tasks[this.model.tasks.length -1]
        },

        deleteAutomaticTask(task) {
            const idx = this.model.tasks.findIndex(t => t == task)
            this.model.tasks.splice(idx,1)
            this.editingTask = null
        },  

        clearValue() {
            this.model.value = null
            if(this.model.contact)
                delete this.model.contact
        },


        save() {

            this.model.filter = FilterHelpers.filterArrayToObject(this.filterArray)

            if(!this.model.width)
                this.model.width = null

            if(this.model.type == 'Contact') {
                this.model.name = StringHelpers.toSnakeCase(this.model.role)
                this.model.title = this.model.role
            }

            this.$emit('save', this.model)
            this.settings.visible = false
        },
        
        cancel() {
            this.$emit('cancel')
            this.settings.visible = false
        },



        deleteElement() {
            this.$emit('delete', this.model)
            this.settings.visible = false            
        },


        setDefaultName() {
            if(this.model.name)
                return
            this.makeElementName(this.model).then(name => {
                Vue.set( this.model, 'name', name)
            })
        },

        makeElementName(element) {   
            return new Promise((resolve, reject) => {
                
                if(!element.title) {
                    resolve('')
                    return
                }
                let name = element.title.replace(/\s|-/g, '_').toLowerCase()

                // special names
                if(['Section', 'Heading', 'Checklist'].indexOf(element.type) >= 0){
                    name = name + '_' + element.type.toLowerCase()
                }

                let baseName = this.getBaseElementName(name)
                this.getSimilarElements(baseName).then(similarElements => {
                    let n = 1
                    while(similarElements.find(o => o.name == name)) {
                        n++
                        name = baseName + '_' + n
                    }
                    resolve(name)
                })
            })         
        },

        getSimilarElements(baseName) {
            return new Promise( (resolve, reject) => {
                let ref = DataHelpers.getTransactionRef().child('elements').orderByChild('name').startAt(baseName)
                ref.once('value', (snap) => {
                    let arr = FirebaseHelpers.snapshotToArray(snap)
                    resolve(arr)
                })
            })
        },

        getBaseElementName(name) {
            if(!name)
                return null

            let nameArray = name.split('_')
            if(nameArray.length ==  1)
                return name

            let lastSegment = nameArray[nameArray.length - 1]
            if(!NumberHelpers.isNumeric(lastSegment))
                return name

            nameArray.splice(nameArray.length - 1, 1)
                return nameArray.join('_')
        },

        deleteFilter(filter) {
            Utilities.log('DeleteFilter')
            let index = this.filterArray.find(o => o.type == filter.type && o.name == filter.name) 
            if(index) 
                this.filterArray.splice(index, 1)
        },

        isVisible(name) {
             let visibleTypes = {}
             visibleTypes.Value = ['Comment', 'Charge']

            if(visibleTypes[name].indexOf(this.model.type) > -1)
                return true
            
            return false
        },

        addFilter() {
            Utilities.log('addFilter')
            this.filterEditorDialog.settings.visible = true
        },
        editFilter(filter) {
            Utilities.log('editFilter')
            this.filterEditorDialog.filter = filter
            this.filterEditorDialog.settings.visible = true
        },        

        saveFilter(filter) {
            let existingFilter = this.filterArray.find(o => o.type == filter.type && o.name == filter.name) 
            if(existingFilter) {
                existingFilter.operator = filter.operator
                existingFilter.values = filter.values
            } else {
                this.filterArray.push(filter)
            }
        },

        goToElementMaintenance() {
            this.$router.push('/maintenance/?action=te&item=' + this.model.key + '&transaction=' + this.model.transactionKey)
        },

        initialiseDialog() {
            Utilities.log('initialiseDialog')

            this.$store.dispatch('fetchAllGroups')
            
            this.$refs.focus.focus()
            this.typeHasValue = this.model.type
            this.nameHasValue = this.model.type
            this.filterArray = FilterHelpers.filterObjectToArray(this.model.filter)
            this.editingTask = null
        },


    },

    watch: {
        'settings.visible' (newVal) {
            if (newVal) {
                setTimeout( () => {
                    this.initialiseDialog()
                }, 300)
            } else {
                setTimeout( () => { 
                    //this.$refs.form.reset() 
                    Utilities.clearProperties(this.model)
                    //this.valid = null
                    this.tab = 'Details'
                }, 300)            
            }

            
        }
    },

    mounted () {

    },   
    
    beforeDestroy() {
        console.log('destroying')   
    }    
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .active-tab {
        background-color: rgba(0,0,0,0.1);
    }

    .action-panel {
        margin-bottom:8px;color:#666;border-radius:4px; border: solid 1px #bbb;display:flex
    }

    .section {
        padding:4px 8px;color:white;background-color: #aaa;font-weight:600;
        border-radius:7px;text-transform: uppercase; margin: 10px 0;
    }

    .element-title-bar {
        padding:5px 10px;
        font-size: 14px;
        text-transform: uppercase;
        letter-spacing: 3px;
        color:#666;
        background-color:#ddd;
    }

</style>


// WEBPACK FOOTER //
// ElementDialog.vue?538a5ad8